import { useEffect, useState } from 'react';
import { loadPromptSkill, type PromptTarget } from '../utils/promptWriter';

/**
 * The generation prompt writer's skill for a kind of prompt, as text, once read (its files are
 * their own piece of the app); null while it is being read, or when no kind is asked for. A
 * Think up card set to Prompt uses it to count the cost of its asking.
 */
export const usePromptSkill = (target: PromptTarget | null): string | null => {
    const [skills, setSkills] = useState<Partial<Record<PromptTarget, string>>>({});
    useEffect(() => {
        if (!target || skills[target]) return;
        let live = true;
        loadPromptSkill(target).then(
            (text) => { if (live) setSkills(prev => ({ ...prev, [target]: text })); },
            (e) => console.warn('[ideas] the prompt writer\'s skill was not read:', e),
        );
        return () => { live = false; };
    }, [target, skills]);
    return target ? skills[target] ?? null : null;
};
